import { useZed } from '@modules/core';
import { TourDanjiModule } from '../TourDanjiModule';
import { useEffectProperty } from './hooks/helper';
import { ArcRotateCamera } from '@babylonjs/core';

export function Camera(
  props: Partial<
    Pick<
      ArcRotateCamera,
      | 'radius'
      | 'lowerRadiusLimit'
      | 'upperRadiusLimit'
      | 'alpha'
      | 'lowerAlphaLimit'
      | 'upperAlphaLimit'
      | 'beta'
      | 'lowerBetaLimit'
      | 'upperBetaLimit'
    >
  >
) {
  const zed = useZed<[TourDanjiModule]>();
  const camera = zed?.api._controller['cameraAPI'].camera;

  useEffectProperty(camera, 'radius', props.radius, false);
  useEffectProperty(camera, 'lowerRadiusLimit', props.lowerRadiusLimit, false);
  useEffectProperty(camera, 'upperRadiusLimit', props.upperRadiusLimit, false);

  useEffectProperty(camera, 'alpha', props.alpha, false);
  useEffectProperty(camera, 'lowerAlphaLimit', props.lowerAlphaLimit, false);
  useEffectProperty(camera, 'upperAlphaLimit', props.upperAlphaLimit, false);

  useEffectProperty(camera, 'beta', props.beta, false);
  useEffectProperty(camera, 'lowerBetaLimit', props.lowerBetaLimit, false);
  useEffectProperty(camera, 'upperBetaLimit', props.upperBetaLimit, false);

  return null;
}
